module.exports = __webpack_public_path__ + "img/footer_word.1ed76300.svg";